import React, { useState } from 'react';
import { useAppContext } from '../../../hooks/AppContext';
import { TextInput, Tooltip } from 'carbon-components-react';
import { prop } from 'ramda';
import { segmentTracking } from '../../../lib/tracker';
import { FormattedMessage } from 'react-intl';
import messages from 'src/apps/envizi-price-estimator/locales/messages';
import { stepProps } from './Step1';

const Step2 = ({ isOpen, question }: stepProps) => {
  const { appState, appAction } = useAppContext();
  const submitted = prop('submitted')(appState);

  const submittedAnsId = submitted && submitted[question.id];
  const submittedAnsValue = submittedAnsId && Object.values(submittedAnsId)[0];
  const [value, setValue] = useState(
    submittedAnsValue ? submittedAnsValue.split(' ')[0] : '',
  );
  const updateValue = (value: string) => {
    setValue(value);
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Location/Facilities input',
      location: 'Assessment',
      action: '',
      field: '',
    });
    appAction({
      type: 'answerInput',
      answerId: 'Q2A1',
      answerValue: `${value} Cookie-${value}`,
    });
  };
  return isOpen ? (
    <div>
      <Tooltip
        tabIndex={5}
        direction={'bottom'}
        onChange={() => {
          segmentTracking('CTA Clicked', {
            pageTitle: 'Envizi Price Estimator',
            object: 'Envizi page',
            resultValue: 'CTA clicked',
            CTA: 'Location/Facilities tooltip',
            location: 'Assessment',
            action: '',
            field: '',
          });
        }}
        triggerText={
          <span className="page_sub_heading padding_8">
            <FormattedMessage {...messages.q2_que_desc} />
          </span>
        }
      >
        <span className="slide_text">
          <FormattedMessage {...messages.tooltip_facility} />
        </span>
      </Tooltip>

      <TextInput
        type="number"
        aria-label="location-facility"
        labelText="Specify total number"
        id="facilities"
        value={value}
        onChange={(e) => updateValue(e.target.value)}
      />
    </div>
  ) : null;
};

export default Step2;
